export const T = {
  en_GB: {
    settings: "Settings",
    combinedInstruments: "Combined Instruments",
    description: "Manage combined instruments and their configurations",
  },
  nb_NO: {
    settings: "Innstillinger",
    combinedInstruments: "Kombinerte instrumenter",
    description: "Administrer kombinerte instrumenter og deres konfigurasjoner",
  },
} as const;
